import {getApiProps} from "@/lib/lib";
import consts from "@/consts";
import range from "lodash/range";
const with_removed = {'force[with_removed]': 1};//String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

let _xRoutesIndexCache = {arr: null, map: null}
function getXRoutesIndexMap(state) {
    if (_xRoutesIndexCache.arr !== state.xRoutes) {
        _xRoutesIndexCache.map = new Map(state.xRoutes.map((u, i) => [u.id, i]))
        _xRoutesIndexCache.arr = state.xRoutes
    }
    return _xRoutesIndexCache.map
}

export default {
    state: {
        xRoutes: [],
    },
    actions: {
        fetchXRoutes/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }
                dispatch('setLastCall', {name: 'fetchXRoutes', args, time: Date.now() / 1000})

                const params = getApiProps('xRoutes', args)
                delete params.unitId;
                this.$api.xroutes.getAll(args?.unitId, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchXRoutes', args, inprogress: false})
                    });
            })
        },
        fetchXRoutesByUnit({commit}, args) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutes', args)
                delete params.unitId;
                this.$api.xroutes.getAll(args?.unitId, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('updateXRoutes', response.data)
                            commit('setXRoutesLiteLoad', true)
                            commit('setXRoutesFullLoad', true)

                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
            })
        },
        fetchXRoutesAll({dispatch, commit}) {
            new Promise((resolve, reject) => {
                const params = getApiProps('xRoutes')
                this.$api.xroutes.getAll(null, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setXRoutes', response.data)
                            commit('setXRoutesLiteLoad', true)
                            commit('setXRoutesFullLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchXRoutesAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchXRoutesAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isXRoutesLiteLoad) {
                    return resolve(getters.getXRoutes.length)
                }
                dispatch('fetchXRoutes', {lite: true})
                    .then((data) => {
                        commit('updateXRoutes', data)
                        //commit('setXRoutesLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchXRoutesAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchXRoutesAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchXRoutesAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchXRoutesChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(null)
                }
                if (!getters.getXRoutes.length) {
                    return resolve([])
                }
                let pageSize = consts.querySettings.pageSize
                let pages = Math.ceil(getters.getXRoutes.length / pageSize)
                let fetch = range(pages).map(i => {
                    let page = i + 1;
                    return dispatch('fetchXRoutes', {page, 'page-size': pageSize, ...args})
                        .then((data) => {
                            commit('updateXRoutes', data)
                        })
                        .catch(() => {
                            dispatch('fetchXRoutes', {page, 'page-size': pageSize, ...args})
                        })
                });
                resolve(fetch)
            })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setXRoutesFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchXRoutesAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchXRoutesChanged', args, inprogress: false})
                })
        },
        fetchXRoutesChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isXRoutesFullLoad) {
                return Promise.resolve(null)
            }
            dispatch('setLastCall', {name: 'fetchXRoutesChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args, ...with_removed}
            return dispatch('fetchXRoutes', args)
                .then((data) => {
                    commit('updateXRoutes', data)
                    return dispatch('fetchXRoutes', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterXRoutes', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchXRoutesChanged', args, inprogress: false})
                });
        },
        reloadXRoutesAll({commit, dispatch}, args) {
            commit('clearXRoutes')
            return dispatch('fetchXRoutesAll', args)
                .then(() => {
                    dispatch('fetchXRoutesAll', args)
                })
        },

        fetchXRoute({commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }
                const params = getApiProps('xRoutes', args)
                delete params.id;
                this.$api.xroutes.find(args.id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRoute', response.data)
                            resolve(true)
                        } else {
                            console.error(response);
                            reject(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(false)
                    });
            });
        },

        saveXRoute({dispatch}, xRoute) {
            let fn = (xRoute.id) ? 'updateXRoute' : 'createXRoute'
            return dispatch(fn, xRoute);
        },
        createXRoute({commit, dispatch}, xRoute) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutes')
                this.$api.xroutes.create(xRoute, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRoute', response.data)
                            dispatch('fetchXRoutesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateXRoute({commit, dispatch}, xRoute) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutes')
                this.$api.xroutes.update(xRoute.id, xRoute, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateXRoute', response.data)
                            dispatch('fetchXRoutesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        deleteXRoute({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('xRoutes')
                this.$api.xroutes.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteXRoute', id)
                            else commit('updateXRoute', response.data)
                            dispatch('fetchXRoutesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
    },
    mutations: {
        removeXRoutes(state, id) {
            state.xRoutes = state.xRoutes.filter(r => id != r.id)
        },
        setXRoutesLiteLoad(state, LiteLoad) {
            state.xRoutesLiteLoad = state.xRoutesLiteLoad || LiteLoad
        },
        setXRoutesFullLoad(state, FullLoad) {
            state.xRoutesFullLoad = state.xRoutesFullLoad || FullLoad
        },

        setXRoutes(state, nXRoutes) {
            nXRoutes = nXRoutes.map(u => {
                //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return Object.freeze(u)
            })
            state.xRoutes = nXRoutes
        },

        updateXRoutes(state, nXRoutes) {
            if (!state.xRoutes.length) {
                nXRoutes = nXRoutes.map(u => {
                    //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return Object.freeze(u)
                })
                state.xRoutes = nXRoutes
                return true
            }

            // console.log('updateXRoutes', state.xRoutes.length)
            const indexById = getXRoutesIndexMap(state)
            nXRoutes.forEach(function (nXRoute) {
                let i = indexById.has(nXRoute.id) ? indexById.get(nXRoute.id) : -1
                if (i < 0) {
                    indexById.set(nXRoute.id, state.xRoutes.length)
                    state.xRoutes.push(Object.freeze(nXRoute))
                } else
                if (state.xRoutes[i][changedField] != nXRoute[changedField]) {
                    // updateObjectByDiff(state.xRoutes[i], nXRoute)
                    delete nXRoute.id
                    state.xRoutes[i] = Object.freeze({...state.xRoutes[i], ...nXRoute})
                }
            })
        },
        filterXRoutes(state, nXRoutes) {
            // let Ids = state.xRoutes.map(u=> u.id)
            let nIds = new Set(nXRoutes.map(u => u.id))
            state.xRoutes = state.xRoutes.filter(u => nIds.has(u.id) || !(u.id > 0))
        },
        updateXRoute(state, nXRoute) {
            let i = state.xRoutes.findIndex(u => (u.id == nXRoute.id))
            if (i < 0) {
                state.xRoutes.push(nXRoute)
            } else
            if (nXRoute.skipChangedField || !state.xRoutes[i][changedField] || state.xRoutes[i][changedField] != nXRoute[changedField]) {
                // updateObjectByDiff(state.xRoutes[i], nXRoute)
                delete nXRoute.skipChangedField;
                let xRoute = {...nXRoute} //ToDo fix
                delete xRoute.id
                state.xRoutes[i] = {...state.xRoutes[i], ...xRoute}
            }
        },
        deleteXRoute(state, id) {
            let i = state.xRoutes.findIndex(u => (u.id == id))
            if (i != -1) {
                state.xRoutes.splice(i, 1)
            }
        },
        clearXRoutes(state, {unitId} = {}) {
            if (unitId) {
                state.xRoutes = state.xRoutes.filter(r => (r.unit_id || r.object_id) != unitId)
            } else {
                state.xRoutes = []
                state.xRoutesLiteLoad = false
                state.xRoutesFullLoad = false
            }
        },
    },
    getters: {
        isXRoutesLiteLoad(state) {
            return state.xRoutesLiteLoad
        },
        isXRoutesFullLoad(state) {
            return state.xRoutesFullLoad
        },
        getXRoutes(state) {
            return state.xRoutes
        },
        getXRoutesByUnitId(state) {
            return state.xRoutes.reduce((out, r) => {
                if(!out[r.unit_id]?.length) out[r.unit_id] = [];
                out[r.unit_id].push(r)
                return out;
            }, {})
        },
        getXRoutesById(state) {
            return state.xRoutes.reduce((out, route) => {
                out[route.id] = route;
                return out;
            }, {})
        },
    }
}